export const sliderItems = [
    {
      id: 1,
      img: "https://blog.apparelnbags.com/wp-content/uploads/2014/11/winter-facebook-banner.jpg",
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://coreldrawdesign.com/resources/previews/preview-winter-sale-banner-fashion-free-vector-design--1607009989.jpg",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://i.ibb.co/cXFnLLV/3.png",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
    },
  ];

  export  const categories = [
    {
      id: 1,
      img: "https://rukminim1.flixcart.com/image/497/596/kkfrjww0/t-shirt/h/1/t/l-t312-cgblwh-new-eyebogler-original-imafzs5hrjgzsfpr.jpeg?q=50",
      title: "SHIRT STYLE!",
      cat:"T-Shirt"
    },
    {
      id: 2,
      img: "https://rukminim1.flixcart.com/image/340/408/kqb8pzk0/jean/q/a/u/36-jk2-mjrp-02-zaysh-original-imag4cenrq5hfhwe.jpeg?q=50",
      title: "JEANS",
      cat:"jeans"
    },
    {
      id: 3,
      img: "https://rukminim1.flixcart.com/image/497/596/kjabs7k0-0/sari/a/h/b/free-brasosari-lorofy-unstitched-original-imafyvdavr2hzyze.jpeg?q=50",
      title: " WOMEN SARI",
      cat:"sari"
    },
  ];

  